import { render, staticRenderFns } from "./借入返済.vue?vue&type=template&id=04447b54&scoped=true&"
import script from "./借入返済.ts?vue&type=script&lang=ts&"
export * from "./借入返済.ts?vue&type=script&lang=ts&"
import style0 from "./借入返済.css?vue&type=style&index=0&id=04447b54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04447b54",
  null
  
)

export default component.exports